__turbopack_context__.v({
  "dimmed": "Intro-module__id83bq__dimmed",
  "enterRow": "Intro-module__id83bq__enterRow",
  "hero": "Intro-module__id83bq__hero",
  "initText": "Intro-module__id83bq__initText",
  "leaving": "Intro-module__id83bq__leaving",
  "lineA": "Intro-module__id83bq__lineA",
  "lineB": "Intro-module__id83bq__lineB",
  "on": "Intro-module__id83bq__on",
  "overlay": "Intro-module__id83bq__overlay",
  "progress": "Intro-module__id83bq__progress",
  "progressSheen": "Intro-module__id83bq__progressSheen",
  "sheen": "Intro-module__id83bq__sheen",
  "stack": "Intro-module__id83bq__stack",
  "tagline": "Intro-module__id83bq__tagline",
  "type-in": "Intro-module__id83bq__type-in",
  "typed": "Intro-module__id83bq__typed",
  "wordmark": "Intro-module__id83bq__wordmark",
});
